import Animation from './Animation'

export default function Name () {
  return (
    <div className='flex flex-col justify-center'>
      <h1 className='
      xl:text-7xl
      lg:text-6xl
      md:text-5xl
      sm:text-4xl
      min-[300px]:text-[40px]
      font-black
      text-center
      self-center'
      >Jerrick Lloyd C
      </h1>
      <Animation />
    </div>
  )
}
